var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@patternfly/react-icons';
import { Button, Icon, Tooltip } from '@patternfly/react-core';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';
const seconds = 1000;
const minutes = seconds * 60;
const hours = minutes * 60;
const days = hours * 24;
const useStyles = createUseStyles({
    inventoryCullingWarning: {
        color: 'var(--pf-t--global--icon--color--status--warning--default)',
    },
    inventoryCullingDanger: {
        color: 'var(--pf-t--global--icon--color--status--danger--default)',
    },
    iconMargin: {
        marginRight: 'var(--pf-t--global--spacer--sm)'
    },
    messageFont: {
        fontWeight: 'var(--pf-t--global--font--weight--body--bold)',
    },
});
const StaleDataWarning = (_a) => {
    var { culled = new Date(0), className, staleWarning = new Date(0), stale = new Date(0), currDate = new Date(0), children, render, message, "aria-label": ariaLabel } = _a, props = __rest(_a, ["culled", "className", "staleWarning", "stale", "currDate", "children", "render", "message", "aria-label"]);
    const classes = useStyles();
    const calculateTooltip = (culled, warning, currDate) => {
        const culledDate = new Date(culled);
        const warningDate = new Date(warning);
        const diffTime = new Date(currDate).valueOf() - warningDate.valueOf();
        const removeIn = Math.ceil((culledDate.valueOf() - new Date(currDate).valueOf()) / days);
        const msg = message ? message : `System scheduled for inventory removal in ${removeIn} days`;
        if (diffTime >= 0) {
            return {
                isError: true,
                msg,
            };
        }
        return {
            isWarn: true,
            msg,
        };
    };
    if (new Date(currDate).valueOf() - new Date(stale).valueOf() < 0) {
        return render
            ? render({
                msg: '',
            })
            : children || null;
    }
    const { isWarn, isError, msg } = calculateTooltip(culled, staleWarning, currDate);
    if (render) {
        return (React.createElement("span", { className: clsx({ [classes.inventoryCullingWarning]: isWarn, [classes.inventoryCullingDanger]: isError }, className) },
            isWarn &&
                React.createElement(Icon, { status: "warning" },
                    React.createElement(ExclamationTriangleIcon, { className: clsx(classes.iconMargin), "aria-label": ariaLabel || "Warning" })),
            isError &&
                React.createElement(Icon, { status: "danger" },
                    React.createElement(ExclamationCircleIcon, { className: clsx(classes.iconMargin), "aria-label": ariaLabel || "Danger" })),
            React.createElement("span", { className: clsx(classes.messageFont) }, render({ msg }))));
    }
    return (React.createElement(React.Fragment, null,
        isError && React.createElement(Tooltip, Object.assign({}, props, { content: React.createElement("div", null, msg) }),
            React.createElement(Button, { variant: "plain", icon: React.createElement(Icon, { status: "warning" },
                    React.createElement(ExclamationTriangleIcon, null)), "aria-label": ariaLabel || "Warning" })),
        isWarn && React.createElement(Tooltip, Object.assign({}, props, { content: React.createElement("div", null, msg) }),
            React.createElement(Button, { variant: "plain", icon: React.createElement(Icon, { status: "danger" },
                    React.createElement(ExclamationCircleIcon, null)), "aria-label": ariaLabel || "Danger" })),
        children));
};
export default StaleDataWarning;
